import { render, staticRenderFns } from "./DepartmentsGrid.vue?vue&type=template&id=79a04d06&scoped=true&"
import script from "./DepartmentsGrid.vue?vue&type=script&lang=ts&"
export * from "./DepartmentsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentsGrid.vue?vue&type=style&index=0&id=79a04d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a04d06",
  null
  
)

export default component.exports